<template>
    <div class="content">
        <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">贵重仪器设备表</h3>
        <div>
            <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
                <!-- <el-form-item label="设备名称">
            <el-input v-model="formInline.device_name" clearable placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery">查询</el-button>
          </el-form-item> -->
                <el-form-item>
                    <el-button type="primary" @click="handleAddData">新增数据</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div>
            <custom-table :data="tableData" border style="width: 100%">
                <custom-table-column fixed label="序号" type="index" width="50">
                </custom-table-column>
                <custom-table-column prop="name" fixed label="名称">
                </custom-table-column>
                <custom-table-column label="文件">
                    <template slot-scope="scope" v-if="scope.row.file_path">
                        <el-link type="primary" v-for="(item, index) in scope.row.file_path.split(',')" :href="item"
                            :key="index" target="_blank">{{ $until.getFileName(item) }}</el-link>
                    </template>
                </custom-table-column>
                <custom-table-column fixed="right" label="操作" width="120">
                    <template slot-scope="scope">
                        <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
                    </template>
                </custom-table-column>
            </custom-table>
            <div class="pageLine">
                <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
            </div>
        </div>
        <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
            <span>是否删除</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="deleteMethod">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinValidate } from '@/assets/js/mixin/validate';

export default {
    name: 'equipmentInto',
    mixins: [mixinList, mixinValidate],
    data() {
        return {
            formInline: {
                name: '',
                type: 1,
            },
            props: {
                emitPath: false
            },
            ruleForm: {
                type: 1,
            },
        };
    },
    components: {},
    created() {
    },
    mounted() {
    },
    methods: {
        handleAddData(){
            this.confirmBox('warning', `是否新增一条数据`, {  }, this.createMethod);
        },
        async deleteMethod() {
            let res = await this.$api.instance.interfaceServer(`api/new-device/training-report/delete/${this.delid}`, 'delete');
            if (res.code == 0) {
                this.$message({
                    type: 'success',
                    center: true,
                    message: '删除成功！',
                });
                this.dialogVisible = false;
                this.handleQuery();
            }
        },
        async getList() {
            let params = this.$until.deleteNullPrototype(this.formInline);
            params.page = this.$refs.pageChild.page;
            params.size = this.$refs.pageChild.size;
            let res = await this.$api.instance.interfaceServer('api/new-device/training-report/list', 'get', params);
            if (res.code == 0 && res.data) {
                this.tableData = res.data.data;
                this.total = res.data.total;
            }
        },
        async createMethod() {
            let params = this.$until.deleteNullPrototype(this.ruleForm);
            let res = await this.$api.instance.interfaceServer('api/new-device/training-report/store', 'post', params);
            if (res.code == 0) {
                this.$message({
                    type: 'success',
                    center: true,
                    message: '新增成功！',
                });
                this.handleQuery()
            }
        },
        handleQuery() {
            this.$refs.pageChild.page = 1;
            this.getList();
        },
    },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
    width: var(--width);
}
</style>